module.exports = __webpack_public_path__ + "img/background_event_2.05a2cc01.png";